<template>
  <b-form-group
    :label="label"
    :label-class="{ required }"
    :invalid-feedback="error"
    :state="error ? false : null">
    <color-picker
      :disabled="disabled"
      :value="fromValue(value)"
      :state="error ? false : null"
      @input="$emit('input', fromValue($event))"
      />
  </b-form-group>
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';

export default {
  mixins: [ FormFieldMixin ],

  props: {
    value: {
      type: String,
      default: undefined
    },
  },

  methods: {
    fromValue(value) {
      if (value === undefined || value === null) {
        return value;
      }

      // console.log('From value', value);

      return value;
    }
  }
};
</script>
